<template>
  <section class="app-updated">
    <GfrLayoutAside class="app-updated-aside">
      <GfrScrollArea
        v-model:reset="resetScroll"
        class="app-updated-catalog-wrapper"
        :initial-y="scrollAreaY"
        :dir="$route.params.lang === 'ar' ? 'rtl' : 'ltr'"
      >
        <ul class="app-updated-catalog-list">
          <li
            :class="['app-updated-catalog-item', item.id == $route.params.id ? 'is__active' : '']"
            v-for="item in articleList.data"
            :key="item.id"
          >
            <NuxtLink class="app-updated-catalog-link" :to="`/${$route.params.lang}/updated/${item.id}`">
              <span>{{ formatTime(item.date) }}</span>
            </NuxtLink>
          </li>
        </ul>
      </GfrScrollArea>
    </GfrLayoutAside>
    <section class="app-updated-content">
      <NuxtPage />
    </section>
  </section>
</template>

<script setup lang="ts">
const resetScroll = ref(false)
const scrollAreaY = ref(0)
const pageStore = usePageStore()
const { fetchPageData, filterModule } = pageStore
const route = useRoute()
await fetchPageData('/cl-updated/') // path与后台定义的path一致
const ModuleCLUpdatedData = filterModule('ModuleCLUpdated')
const { fetchArticleList } = useArticleStore()
const articleList = await fetchArticleList(1, 1, 30, 'category', ModuleCLUpdatedData.category_id)
const firstArticle = computed(() => articleList.data[0])
function navigateToFirstArticle() {
  if (firstArticle.value.id && !route.params.id) {
    navigateTo(`/${route.params.lang}/updated/${firstArticle.value.id}`)
  }
}
function setScrollAreaY() {
  const activeElem = document.querySelector('.app-updated-catalog-item.is__active') as HTMLElement
  scrollAreaY.value = activeElem ? activeElem.offsetTop : 0
}
navigateToFirstArticle()
watch(
  () => route.params.id,
  async (value) => {
    if (value) {
      await nextTick()
      setScrollAreaY()
    }
  }
)
onUpdated(() => {
  navigateToFirstArticle()
})
</script>

<style lang="scss" scoped>
.app-updated {
  @apply relative flex ltr:pl-9 ltr:pr-17 rtl:pl-17 rtl:pr-9 pt-5;
}
.app-updated-aside {
  @apply sticky top-[104px] h-[calc(100vh-104px)] w-[264px] flex-shrink-0 ltr:border-r rtl:border-l border-[#4D5158];
}
.app-updated-catalog-wrapper {
  @apply w-full text-2xl h-full;
}
.app-updated-catalog-item {
  @apply mb-2;
}
.app-updated-catalog-link {
  @apply inline-flex h-15 py-2 w-full items-center px-[34px] transition-colors duration-300;
}
.app-updated-catalog-link.router-link-exact-active {
  @apply ltr:bg-gradient-to-l rtl:bg-gradient-to-r from-transparent to-[#363A41] text-primary;
}
.app-updated-content {
  @apply relative flex flex-col flex-1 pb-16 ltr:pl-8 rtl:pr-8;
}
</style>
